import {createElement} from "../utils/common";
import {
  getNotificationCallUserTemplate,
  getNotificationChangePriorityTemplate,
  getNotificationCloseTemplate,
  getNotificationCommentTemplate,
  getNotificationCreateTemplate,
  getNotificationDeadlineTemplate,
  getNotificationOpenTemplate,
  getNotificationResponsibleTemplate,
  getNotificationSubscribersTemplate,
} from "./templates";

export const renderNotificationElement = (parent, template, isPrepend) => {
  const element = createElement(template);
  if (isPrepend) {
    parent.prepend(element);
  } else {
    parent.append(element);
  }
  return element;
};

export const getTemplate = (type) => {
  switch (type) {
    case `create`:
      return getNotificationCreateTemplate;
    case `open`:
      return getNotificationOpenTemplate;
    case `close`:
      return getNotificationCloseTemplate;
    case `comment`:
      return getNotificationCommentTemplate;
    case `responsible`:
      return getNotificationResponsibleTemplate;
    case `deadline`:
      return getNotificationDeadlineTemplate;
    case `subscriber`:
      return getNotificationSubscribersTemplate;
    case `callUser`:
      return getNotificationCallUserTemplate;
    case `changePriority`:
      return getNotificationChangePriorityTemplate;
  }
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);

  return `${date.getFullYear()}-${(`0` + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
};

export const replaceMnemonicSymbols = (string) => {
  return string.replaceAll(`&amp;nbsp;`, ` `).replaceAll(`&amp;laquo;`, `«`).replaceAll(`&amp;raquo;`, `»`).replaceAll(`&amp;mdash;`, `—`).replaceAll(`&amp;mdash;`, `—`);
};
